import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { FormikInput } from '../../components';
import AttendanceHashDataTable from './AttendanceHashDataTable';

const AttendanceHashIndex = ({ match }) => {
  const [hash, setHash] = useState('');
  const [moreData, setMoreData] = useState(false);
  const isDt = match.params.is_dt;
  return (
    <>
      <Row className="m-top mb-4">
        <Col>
          <div className="d-flex align-items-center">
            <div className="d-flex flex-column ml-1">
              <h2 className={`mt-3 ${isDt ? 'h2-dt' : ''}`}>Busqueda de Asistencia por Hash</h2>
            </div>
          </div>
        </Col>
        <Col md={3}>
          <FormikInput
            label="Hash"
            name="rut"
            placeholder="Ingresa un Hash"
            onChange={data => {
              setHash(data ? data.target.value : '');
              setMoreData(!moreData);
            }}
            value={hash}
          />
        </Col>
      </Row>
      <AttendanceHashDataTable moreData={moreData} customParams={{ filter_by_hash: hash }} />
    </>
  );
};

export default AttendanceHashIndex;
